"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Routes - initiates the client side routes
 */
// these 2 required old-style require()
var qs = require('qs');
var page = require('page');
var session_timer_util_1 = require("./utils/timers/session-timer.util");
var route_1 = require("./actions/route");
var ui_1 = require("./actions/ui");
var client_error_logger_1 = require("./utils/logging/client-error-logger");
var constants_1 = require("./constants");
var BASE_URI = constants_1.default.BASE_URI, ROUTES = constants_1.default.ROUTES, PAGES = constants_1.default.PAGES, VIEWS = constants_1.default.VIEWS, FLOWS = constants_1.default.FLOWS;
/**
 * If client route does not define certain route, it will go to server.
 *
 * @param store
 */
function initRoutes(store) {
    function parseQuery(context, next) {
        context.query = qs.parse(context.querystring) || {};
        next();
    }
    // We need 2 named arguments for chaining in page.js and second one is the next function
    function startTimer(context, next) {
        if (context.canonicalPath.includes(BASE_URI) &&
            !context.canonicalPath.includes('logout') &&
            !context.canonicalPath.includes('unsubscribe') &&
            !context.canonicalPath.includes('cookies') &&
            !context.canonicalPath.includes('extend-session')) {
            var state = store.getState(), _a = state.route, _b = (_a === void 0 ? {} : _a).enter, _c = (_b === void 0 ? {} : _b).view, enterView = _c === void 0 ? '' : _c, currentPath = context.canonicalPath.slice((BASE_URI + '/').length);
            session_timer_util_1.default(enterView, currentPath);
        }
        next();
    }
    function triggerFPTI(context, next) {
        if (window && window.PAYPAL && window.PAYPAL.fpti) {
            setTimeout(function () {
                window.PAYPAL.fpti.triggerFPTIImpression();
            }, 200);
        }
        next();
    }
    function handleError(error) {
        var _a = store.getState().content, content = _a === void 0 ? {} : _a;
        // Catch unexpected errors and report to server
        if (error.stack || error.message) {
            client_error_logger_1.default.log(store, '/flow/error', 'ROUTING_ERROR', '', '', '', error);
            // Switch to client error message to show users
            error = 'CLIENT_ERROR';
        }
        store.dispatch(ui_1.updateUI({
            showSpinner: false,
            component: { name: 'Component Name here' },
            error: content.errors[error] || error
        }));
    }
    function closeModal(context, viewName, previouslyOpen) {
        var params = context.params, query = context.query, dispatch = store.dispatch;
        dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: viewName,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: true,
                view: viewName,
                slide: 0,
                params: params,
                query: query
            }
        }));
    }
    function openModal(context, viewName) {
        var params = context.params, query = context.query, dispatch = store.dispatch;
        dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: viewName,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: true,
                view: viewName,
                slide: 1,
                params: params,
                query: query
            }
        }));
    }
    page.base(BASE_URI);
    page('*', parseQuery, startTimer, triggerFPTI);
    page('/flow/cookies', function (context) {
        // DO NOTHING
        // cookie pref page uses href for scrolling
        // hence, we don't want it to enter server 
        // side routing causing refresh
        // cookie pref needs to be refactored
    });
    // Main account page
    page(ROUTES.ACCOUNT, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.ACCOUNT,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    // Main notifications page
    page(ROUTES.NOTIFICATIONS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.NOTIFICATIONS,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    // Main security page
    page(ROUTES.SECURITY, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.SECURITY,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    // Seller Tools
    page(ROUTES.SELLER_TOOLS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.SELLER_TOOLS,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    // Main Cookies  page
    page(ROUTES.COOKIES, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.COOKIES,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    // Main security page
    page(ROUTES.PAYMENTS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: false,
                view: PAGES.PAYMENTS,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    // Email routes
    page(ROUTES.EMAILS.ADD, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.EMAILS.ADD,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page(ROUTES.EMAILS.EDIT + '/:id', function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.EMAILS.EDIT,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.EMAILS.EDIT,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page.exit(ROUTES.EMAILS.EDIT + '/:id', function (context, next) {
        closeModal(context, VIEWS.EMAILS.EDIT, true);
        return next();
    });
    page(ROUTES.PASSPORT.UPDATE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page.exit(ROUTES.PASSPORT.UPDATE, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT, true);
        return next();
    });
    page(ROUTES.PASSPORT.DELETE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page.exit(ROUTES.PASSPORT.DELETE, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT, true);
        return next();
    });
    page(ROUTES.PASSPORT.DELETE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page.exit(ROUTES.PASSPORT.DELETE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT_SUCCESS, true);
        return next();
    });
    page('/flow' + ROUTES.PASSPORT.DELETE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            isFlow: true
        }));
    });
    page.exit('/flow' + ROUTES.PASSPORT.DELETE, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT, true);
        return next();
    });
    page('/flow' + ROUTES.PASSPORT.DELETE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.DELETE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            isFlow: true
        }));
    });
    page.exit('/flow' + ROUTES.PASSPORT.DELETE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.DELETE_PASSPORT_SUCCESS, true);
        return next();
    });
    page('/flow' + ROUTES.PASSPORT.UPDATE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            isFlow: true
        }));
    });
    page.exit('/flow' + ROUTES.PASSPORT.UPDATE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT_SUCCESS, true);
        return next();
    });
    page('/flow' + ROUTES.PASSPORT.UPDATE, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT,
                slide: 0,
                params: params,
                flow: FLOWS.PASSPORT_PAGE,
                query: query
            },
            isFlow: true
        }));
    });
    page.exit('/flow' + ROUTES.PASSPORT.UPDATE, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT, true);
        ;
        next();
    });
    page(ROUTES.PASSPORT.UPDATE_SUCCESS, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query
            },
            exit: {
                overpanel: false,
                view: VIEWS.UPDATE_PASSPORT_SUCCESS,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page.exit(ROUTES.PASSPORT.UPDATE_SUCCESS, function (context, next) {
        closeModal(context, VIEWS.UPDATE_PASSPORT_SUCCESS, true);
        return next();
    });
    // Extend User's Session
    page(ROUTES.EXTEND_SESSION, function (context) {
        var query = context.query, params = context.params;
        store.dispatch(route_1.clearRoute());
        store.dispatch(route_1.default({
            enter: {
                overpanel: true,
                view: VIEWS.EXTEND_SESSION,
                slide: 0,
                params: params,
                query: query
            }
        }));
    });
    page.start();
}
exports.default = initRoutes;
